// extracted by mini-css-extract-plugin
export var compactFilters = "_cu-4";
export var detailImage = "_cu-1";
export var dropdownContainer = "_cu-2";
export var imageContainer = "_cu-0";
export var selectedCard = "_cu-3";